export default "__VITE_ASSET__hX3_zjAF__"